export default class SemiParallelSequence<T> {
  private running = 0;

  private requestQueue: Request<T>[] = [];

  constructor(private maxParallel: number) {}

  public fetch(execution: () => Promise<T>): Promise<T> {
    if (this.running < this.maxParallel) {
      this.running += 1;
      return execution()
        .then((value) => {
          this.executeNext();
          return value;
        })
        .catch((error) => {
          this.executeNext();
          throw error;
        });
    }
    return new Promise<T>((onSuccess, onError) => {
      this.requestQueue.unshift({ execution, onSuccess, onError });
    });
  }

  private executeNext() {
    this.running -= 1;
    const request = this.requestQueue.pop();
    if (request) {
      this.running += 1;
      request
        .execution()
        .then((value) => {
          request.onSuccess(value);
          this.executeNext();
        })
        .catch((error) => {
          request.onError(error);
          this.executeNext();
        });
    }
  }
}

interface Request<T> {
  execution: () => Promise<T>;
  onSuccess: (value?: T | PromiseLike<T>) => void;
  onError: (reason?: unknown) => void;
}
